"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isTypeQueryBody = void 0;
const datastoreTypes_1 = require("../datastoreTypes");
const isTypeQueryBody = (something) => something.type === datastoreTypes_1.QueryTypes.searchByType;
exports.isTypeQueryBody = isTypeQueryBody;
